import { z } from 'zod';

export const rewardsPairSchema = z.object({
  exp: z.number().int().nonnegative(),
  coins: z.number().int().nonnegative(),
});
export const campaignListSchema = z.object({
  data: z.array(
    z.object({ id: z.string().min(1), name: z.string(), packIds: z.array(z.string()), published: z.boolean() }),
  ),
  total: z.number().int().nonnegative(),
});
export const campaignProgressPackSchema = z
  .object({
    packId: z.string().min(1),
    currentQuestionId: z.string().min(1).optional(),
    rewardGranted: z.boolean().optional(),
    questionCount: z.number().int().positive(),
    solvedCount: z.number().int().nonnegative(),
    status: z.string(),
    locked: z.boolean(),
    lockReason: z.string().optional(),
    earnedRewards: rewardsPairSchema,
    totalRewards: rewardsPairSchema,
  })
  .refine((pack) => pack.solvedCount <= pack.questionCount, 'Invalid campaign progress');
export type CampaignProgressPack = z.infer<typeof campaignProgressPackSchema>;
export const parseCampaignProgressPack = (value: unknown) => campaignProgressPackSchema.safeParse(value);

export const readPublishedCampaigns = async (
  readPage: (query: { limit: number; offset: number }) => Promise<unknown>,
) => {
  const result: z.infer<typeof campaignListSchema>['data'] = [];
  let total = Infinity;
  while (result.length < total) {
    const page = campaignListSchema.parse(await readPage({ limit: 100, offset: result.length }));
    total = page.total;
    if (!page.data.length && result.length < total) throw new Error('Incomplete campaign catalogue');
    result.push(...page.data);
  }
  if (new Set(result.map((item) => item.id)).size !== result.length) throw new Error('Duplicate campaign ID');
  return result.filter((item) => item.published);
};
